export const postIframeData = (iframeData: {
  height: number;
  location: string;
  hostOrigin: string;
}): void => {
  window.parent.postMessage(iframeData, iframeData.hostOrigin);
};
